<template>
  <div class="camera container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--表格数据-->
    <div class="col-2">
      <el-form ref="queryForm" class="pagination-table-query-form" :inline="true"
               @keyup.enter.native="handleFormQuery()">
        <el-form-item label="建档状态" class="right-vertical-line pr15">
          <el-checkbox-group v-model="tableQueryParams.archiveStatuss">
            <el-checkbox v-for="archiveStatus in $type.archiveStatuss" :key="archiveStatus.id"
                         :label="archiveStatus.id">{{archiveStatus.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="更新日期">
          <uni-date-range-picker
            v-model="dates"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </uni-date-range-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
          <el-button @click="resetQueryForm()">重 置</el-button>
        </el-form-item>
      </el-form>
      <div class="pagination-table-button-container">
        <el-button @click="handleAdd" type="primary">新 增</el-button>
        <el-button type="primary" @click="handleDelete()" :disabled="!tableSelectedIds.length">批量删除</el-button>
        <el-button type="danger" @click="handleClear">清 空</el-button>
        <el-button type="primary" @click="handleImport()">导 入</el-button>
        <el-button type="primary" @click="handleExport()">导 出</el-button>
        <el-dropdown @command="handleImportFromStreamNode">
          <el-button type="primary" class="large-button">
            节点同步<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">完全同步</el-dropdown-item>
            <el-dropdown-item command="1">同步新增记录</el-dropdown-item>
            <el-dropdown-item command="2">同步修改记录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="pagination-table-container">
        <el-table :data="tableData"
                  ref="table"
                  border highlight-current-row
                  v-loading="loading"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                  element-loading-spinner="el-icon-loading"
                  element-loading-text="努力加载中..."
                  style="width: 100%"
                  @selection-change="handleTableSelectionChange"
                  @current-change="handleTableCurrentChange">>
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="名称" prop="name" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="摄像机类型" prop="streamObjectKind" width="100">
            <template slot-scope="scope"> {{getNameById(scope.row.resourceSubType, $type.streamObjectKinds)}} </template>
          </el-table-column>
          <el-table-column label="IP" prop="ip" width="140"></el-table-column>
          <el-table-column label="端口" prop="port" width="80"></el-table-column>
          <el-table-column label="厂家" prop="manufactor"></el-table-column>
          <el-table-column label="品牌" prop="brand"></el-table-column>
          <el-table-column label="型号" prop="model"></el-table-column>
          <el-table-column label="过保日期" prop="expiryDate" width="140">
            <template slot-scope="scope">
              <el-tag :type="dateExpired(scope.row.expiryDate)  ? 'danger': 'primary'">
                {{strDateFromInt(scope.row.expiryDate)}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="所属区域" prop="regionId" :show-overflow-tooltip="true">
            <template slot-scope="scope"> {{getNameById(scope.row.regionId, $globalData.regions)}} </template>
          </el-table-column>
          <el-table-column label="建档状态" prop="archiveStatus" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.archiveStatus == 1 ? 'warning':
              scope.row.archiveStatus == 2 ? 'warning':
              scope.row.archiveStatus == 3 ? 'primary' : 'danger'">
                {{getNameById(scope.row.archiveStatus, $type.archiveStatuss)}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <el-button
                class="col-btn"
                type="text"
                icon="el-icon-edit"
                @click="handleModify(scope.row)"
              >修改
              </el-button>
              <el-button
                class="col-btn"
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentPageChange"
          @size-change="handlePageSizeChange"
          :current-page.sync="tableQueryParams.pageNum"
          :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
          :page-size.sync="tableQueryParams.pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableTotalRow">
        </el-pagination>
      </div>
      <!--接入、资产、建设、使用、运维等信息内容-->
      <div class="general-container">
        <el-tabs v-model="activeTabName">
          <el-tab-pane label="接入信息" name="0">
            <ul class="label-value-list">
              <li><span class="label">名称</span><span class="value">{{ tableCurrentRow.name }}</span></li>
              <li><span class="label">IP</span><span class="value">{{ tableCurrentRow.ip }}</span></li>
              <li><span class="label">端口</span><span class="value">{{ tableCurrentRow.port }}</span></li>
              <li><span class="label">用户名</span><span class="value">{{ tableCurrentRow.userName }}</span></li>
              <li><span class="label">登录口令</span><span class="value">{{ tableCurrentRow.password }}</span></li>
            </ul>
            <ul class="label-value-list">
              <li><span class="label">接入设备</span><span class="value">{{ getNameById(tableCurrentStreamNode.encoderId, $globalData.encoders)}}</span></li>
              <li><span class="label">接入通道号</span><span class="value">{{ tableCurrentStreamNode.encoderVideoInputNum }}</span></li>
              <li><span class="label">流访问模式</span><span class="value">{{ getNameById(tableCurrentStreamNode.streamOpenMode,$type.streamOpenModes) }}</span></li>
              <li><span class="label">所属区域</span><span class="value">{{ getNameById(tableCurrentRow.regionId, $globalData.regions) }}</span></li>
              <li><span class="label">接入状态</span><span class="value">{{ $type.getResourceAlarmStateText(21, tableCurrentStreamNode.alarmState, tableCurrentStreamNode.eventTypeSet, 1, tableCurrentStreamNode.encoderAlarmState, tableCurrentStreamNode.encoderEventTypeSet)}}</span></li>
            </ul>
            <ul class="label-value-list">
              <li><span class="label">资源代码</span><span class="value">{{ tableCurrentStreamNode.resourceCode }}</span></li>
              <li><span class="label">密级程度</span><span class="value">{{ getNameById(tableCurrentRow.secrecy,$type.secrecys) }}</span></li>
              <li><span class="label">注册方式</span><span class="value">{{ getNameById(tableCurrentRow.registerWay,$type.registerWays) }}</span></li>
              <li><span class="label">信令安全模式</span><span class="value">{{ getNameById(tableCurrentRow.safetyWay,$type.safetyWays) }}</span></li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="设备信息" name="1">
            <ul class="label-value-list">
              <li><span class="label">资产编号</span><span class="value">{{ tableCurrentRow.assetNum }}</span></li>
              <li><span class="label">摄像机类型</span><span class="value">{{ getNameById(tableCurrentRow.resourceSubType, $type.streamObjectKinds) }}</span></li>
              <li><span class="label">厂商</span><span class="value">{{ tableCurrentRow.manufactor }}</span></li>
              <li><span class="label">品牌</span><span class="value">{{ tableCurrentRow.brand }}</span></li>
              <li><span class="label">型号</span><span class="value">{{ tableCurrentRow.model }}</span></li>
            </ul>
            <ul class="label-value-list">
              <li><span class="label">规格</span><span class="value">{{ tableCurrentRow.spec }}</span></li>
              <li><span class="label">过保日期</span><span class="value">{{ strDateFromInt(tableCurrentRow.expiryDate) }}</span></li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="建设信息" name="2">
            <ul class="label-value-list">
              <li><span class="label">安装地点</span><span class="value">{{ tableCurrentRow.installationPlace }}</span></li>
              <li><span class="label">安装日期</span><span class="value">{{ strDateFromInt(tableCurrentRow.installationDate) }}</span></li>
              <li><span class="label">设备归属</span><span class="value">{{  getNameById(tableCurrentRow.ownerDepartmentId, $globalData.departments) }}</span></li>
              <li><span class="label">建设单位联系人</span><span class="value">{{ getNameById(tableCurrentRow.ownerPersonId, $globalData.persons) }}</span></li>
              <li><span class="label">建设单位联系电话</span><span class="value">{{ tableCurrentOwnerPersonPhone }}</span></li>
            </ul>
            <ul class="label-value-list">
              <li><span class="label">所属项目</span><span class="value">{{ getNameById(tableCurrentRow.projectId, $globalData.projects) }}</span></li>
              <li><span class="label">行政编码</span><span class="value">{{ tableCurrentRow.civilCode }}</span></li>
              <li><span class="label">经度</span><span class="value">{{ tableCurrentRow.longitude }}</span></li>
              <li><span class="label">纬度</span><span class="value">{{ tableCurrentRow.latitude }}</span></li>
              <li><span class="label">室内室外</span><span class="value">{{ getNameById(tableCurrentRow.roomType, $type.roomTypes) }}</span></li>
            </ul>
            <ul class="label-value-list">
              <li><span class="label">安装位置类型</span><span class="value">{{ getNameById(tableCurrentRow.positionType, $type.positionTypes) }}</span></li>
              <li><span class="label">监视方位</span><span class="value">{{ tableCurrentRow.expandInfo }}</span></li>
              <li><span class="label">取流方式</span><span class="value">{{ tableCurrentRow.expandInfo }}</span></li>
              <li><span class="label">是否有拾音器</span><span class="value">{{ tableCurrentRow.expandInfo }}</span></li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="维保信息" name="3">
            <ul class="label-value-list">
              <li><span class="label">维保单位</span><span class="value">{{ getNameById(tableCurrentRow.maintenanceDepartmentId, $globalData.departments) }}</span></li>
              <li><span class="label">维保负责人</span><span class="value">{{ getNameById(tableCurrentRow.maintenancePersonId, $globalData.persons) }}</span></li>
              <li><span class="label">维保联系电话</span><span class="value">{{ tableCurrentMaintenancePersonPhone }}</span></li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="应用信息" name="4">
            <ul class="label-value-list">
              <li><span class="label">所属辖区</span><span class="value">{{ tableCurrentRow.block }}</span></li>
              <li><span class="label">用途</span><span class="value">{{ getNameById(tableCurrentRow.useType, $type.useTypes) }}</span></li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="图片及附件" name="5">
            <div class="image-block ml0" style="width: 320px;height: 240px">
<!--              <span class="demonstration">现场图片</span>-->
              <el-image :src="tableCurrentRow.pictureUrl" :preview-src-list="tableCurrrentPreviewPictureUrls">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--新增或修改摄像机-->
    <el-dialog
      :title="modalForm.id ? '修改摄像机' : '新增摄像机'"
      :visible="modalOpen"
      :append-to-body="true"
      width="1000px"
      :before-close="handleModalCancel"
    >
      <el-form ref="modalForm" inline class="camera-form" :model="modalForm" :rules="formRules" labelWidth="120px">
        <el-tabs v-model="modalActiveTabName">
          <el-tab-pane label="接入信息" name="0">
            <el-form-item label="名称" prop="name">
              <el-input v-model="modalForm.name" placeholder="请输入名称" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="IP" prop="ip">
              <el-input v-model="modalForm.ip" placeholder="请输入IP" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="端口" prop="port">
              <el-input v-model="modalForm.port" placeholder="请输入端口" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="modalForm.userName" placeholder="请输入用户名" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="登录口令" prop="password">
              <el-input v-model="modalForm.password" placeholder="请输入登录口令" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="所属区域" prop="regionId">
              <el-select v-model="modalForm.regionId" placeholder="请选择所属区域" :style="{width: '300px'}">
                <el-option v-for="item in $globalData.regions" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="密级程度" prop="secrecy">
              <el-select v-model="modalForm.secrecy" placeholder="请选择密级程度" :style="{width: '300px'}">
                <el-option v-for="item in $type.secrecys" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注册方式" prop="registerWay">
              <el-select v-model="modalForm.registerWay" placeholder="请选择注册方式" :style="{width: '300px'}">
                <el-option v-for="item in $type.registerWays" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="信令安全模式" prop="safetyWay">
              <el-select v-model="modalForm.safetyWay" placeholder="请选择信令安全模式" :style="{width: '300px'}">
                <el-option v-for="item in $type.safetyWays" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="设备信息" name="1">
            <el-form-item label="资产编号" prop="assetNum">
              <el-input v-model="modalForm.assetNum" placeholder="请输入资产编号" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="摄像机类型" prop="resourceSubType">
              <el-select v-model="modalForm.resourceSubType" placeholder="请选择摄像机类型" :style="{width: '300px'}">
                <el-option v-for="item in $type.streamObjectKinds" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="厂商" prop="manufactor">
              <el-input v-model="modalForm.manufactor" placeholder="请输入厂商" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="品牌" prop="brand">
              <el-input v-model="modalForm.brand" placeholder="请输入品牌" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="型号" prop="model">
              <el-input v-model="modalForm.model" placeholder="请输入型号" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="规格" prop="spec">
              <el-input v-model="modalForm.spec" placeholder="请输入规格" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="过保日期" prop="expiryDate">
              <el-date-picker type="date" placeholder="选择日期" v-model="expiryDate" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="建设信息" name="2">
            <el-form-item label="安装地点" prop="installationPlace">
              <el-input v-model="modalForm.installationPlace" placeholder="请输入安装地点" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="安装日期" prop="installationDate">
              <el-date-picker type="date" placeholder="选择日期" v-model="installationDate" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="建设单位" prop="ownerDepartmentId">
              <el-select v-model="modalForm.ownerDepartmentId" placeholder="请选择建设单位" :style="{width: '300px'}">
                <el-option v-for="item in $globalData.departments" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="建设单位联系人" prop="ownerPersonId">
              <el-select v-model="modalForm.ownerPersonId" placeholder="请选择建设单位联系人" :style="{width: '300px'}">
                <el-option v-for="item in $globalData.persons" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行政编码" prop="civilCode">
              <el-input v-model="modalForm.civilCode" placeholder="请输入行政编码" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="modalForm.longitude" placeholder="请输入经度" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="modalForm.latitude" placeholder="请输入纬度" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="海拔" prop="altitude">
              <el-input v-model="modalForm.altitude" placeholder="请输入海拔" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="室内室外" prop="roomType">
              <el-select v-model="modalForm.roomType" placeholder="请选择室内室外" :style="{width: '300px'}">
                <el-option v-for="item in $type.roomTypes" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安装位置类型" prop="positionType">
              <el-select v-model="modalForm.positionType" placeholder="请选择安装位置类型" :style="{width: '300px'}">
                <el-option v-for="item in $type.positionTypes" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属项目" prop="projectId">
              <el-select v-model="modalForm.projectId" placeholder="请选择所属项目" :style="{width: '300px'}">
              </el-select>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="维保信息" name="3">
            <el-form-item label="维保单位" prop="maintenanceDepartmentId">
              <el-select v-model="modalForm.maintenanceDepartmentId" placeholder="请选择维保单位" :style="{width: '300px'}">
                <el-option v-for="item in $globalData.departments" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维保负责人" prop="maintenancePersonId">
              <el-select v-model="modalForm.maintenancePersonId" placeholder="请选择维保负责人" :style="{width: '300px'}">
                <el-option v-for="item in $globalData.persons" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="应用信息" name="4">
            <el-form-item label="所属辖区" prop="block">
              <el-input v-model="modalForm.block" placeholder="请输入所属辖区" clearable :style="{width: '300px'}"></el-input>
            </el-form-item>
            <el-form-item label="用途" prop="useType">
              <el-select v-model="modalForm.useType" placeholder="请选择用途" :style="{width: '300px'}">
                <el-option v-for="item in $type.useTypes" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="图片及附件" name="5">
            <div class="image-block" style="width: 480px;height: 360px">
<!--              <span class="demonstration">现场图片</span>-->
              <el-image :src="modalForm.pictureUrl" fit="scale-down">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <el-upload
              class="mt5"
              :action="modalUpload.url"
              :show-file-list="false"
              :before-upload="handleModalBeforeUpload"
              :on-success="handleModalUploadSuccess">
              <el-button type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip mb5">只能上传jpg/png文件，且不超过500kB</div>
            </el-upload>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleModalSubmit" type="primary">确定</el-button>
        <el-button @click="handleModalCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Camera from './Camera.js'
export default Camera
</script>

<style lang="scss">
  @import "Camera";
</style>



// WEBPACK FOOTER //
// src/views/assets/camera/Camera.vue